<!--
 * @Author: 张天昊
 * @Date: 2024-11-13 10:49:59
 * @LastEditTime: 2024-11-15 14:29:25
 * @LastEditors: 张天昊
 * @Description: 一机管个人信息收集清单页面（配个2024.11隐私调整）
 * @FilePath: /Mobile/src/pages/index/privacyInfo.vue
-->
<template>
  <div class="home">
    <!-- 页首 -->
    <div class="section">
      <div class="intro">
        一部手机管旅游将尽全力保护您的个人信息安全,并保障您在个人信息处理过程中的相关权益。为了向您提供一部手机管旅游的基本功能及附加功能,我们需要收集您在使用服务时通过您主动授权提供的方式产生的个人信息。以下我们将逐一说明收集情况,方便您快速查阅。
      </div>
    </div>
    <div v-for="(item, i) in infoListData" :key="i">
      <PrivacyInfoBody
        :showLine="i == infoListData.length - 1 ? !showLine : showLine"
        :infoItem="item"
      ></PrivacyInfoBody>
    </div>
  </div>
</template>

<script>
import PrivacyInfoBody from './components/PrivacyInfoBody.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    PrivacyInfoBody
  },
  data() {
    return {
      showLine: true,
      pageTitle: '个人信息收集',
    };
  },
  computed: {
    ...mapState('privacy', ['infoListData'])
  },

  async mounted() {
    let _this = this;

    _this.setAppTitle('个人信息收集');

    _this.init(this.$route.query);
  },

  methods: {
    ...mapActions('privacy', ['fetchPrivacyPageInfo']),
    setAppTitle: function (title) {
      try {
        window.yyn.app.invoke('setTitle', title);
      } catch (e) {
        console.log('设置app标题错误，' + e.message);
      }
    },

    // network
    async init() {
      await this.fetchPrivacyPageInfo()
    }
  }
};
</script>
<style lang="less" scoped>
.section {
  margin-top: 2.4px; /*px*/
  background-color: rgb(255, 255, 255);
  .intro {
    font-size: 12px;
    font-family: 'PingFangSC-Regular';
    line-height: 20px;
    color: rgb(153, 153, 153);
    padding: 16px;
  }
}
</style>
